import $ from "jquery";
import GameLogic from "@bd-core/game-logic";
import CONFIG from "@bd-core/config";
import Storage from "@bd-utils/storage";
import {
    currentPageIsMainRoom,
    getCurrentPageId,
} from "@bd-stores/user-progress";
import bdjs from "@bd-core/bdjs";

export default class CompletionPopup {
    constructor() {
        this.elms = {
            popup: ".js-room-completion",
            closeBtn: ".js-completionPopup-close",
            goToMainRoom: ".js-completionPopup-goto",
        };

        return this;
    }

    init() {
        const self = this;
        const elms = this.elms;
        const $popup = $(elms.popup);

        $popup.find(elms.closeBtn).on("click", this.hide.bind(this));
        $popup.find(elms.goToMainRoom).on("click", function () {
            const currentPageID = getCurrentPageId();

            self.hide();
            $(".timer").removeClass("is-clues-equation");

            const mainRoomID = CONFIG?.game?.rooms.find(
                (key) => key.id == currentPageID,
            ).mainroom_id;

            GameLogic.goToPage(mainRoomID);
        });

        return this;
    }

    _setHasSeen(roomId) {
        let states = Storage.get("states", {});
        if (!states?.completions) states.completions = [];
        states.completions.push(roomId);
        return Storage.set("states", states);
    }

    _getHasSeen(roomId) {
        let states = Storage.get("states", {});
        return states?.completions && states.completions.includes(roomId);
    }

    maybeResetState(roomId) {
        if (!this._getHasSeen(roomId)) return false;

        let states = Storage.get("states", {});
        if (!states?.completions) states.completions = [];

        const initialLength = states.completions.length;
        const completions = bdjs.removeItemArray(states.completions, roomId);

        //There is item removed, we need to update the Storage
        if (completions.length !== initialLength) {
            states.completions = completions;
            return Storage.set("states", states);
        }

        return false;
    }

    show(roomId, isMiddleState, roomAnswers) {
        // display completion popup only in current challenge room and main room
        const showThisInRoom = ["main-room", roomId];
        const currentPageId = getCurrentPageId();
        const isCurrentPageMainroom = currentPageIsMainRoom();
        const hasSeen = this._getHasSeen(roomId);

        if (hasSeen && !showThisInRoom.includes(currentPageId)) return;

        if (hasSeen && isCurrentPageMainroom) return;

        const rooms = CONFIG?.game?.rooms || false;

        if (!Array.isArray(rooms) || !rooms.length) return;

        const room = rooms.find((r) => r?.id == roomId);
        if (!room) return;
        let $popup = $(this.elms.popup);
        let title = room?.room?.completion_popup?.title || false;
        let text = room?.room?.completion_popup?.content || false;
        let withClose = room?.room?.completion_popup?.closeBtn || false;

        if (isMiddleState) {
            let middleStateCounter = 0;

            if (typeof roomAnswers == "object") {
                $.each(roomAnswers, (answerId, objAnswer) => {
                    if (objAnswer?.isMiddleState) middleStateCounter++;
                });
            }

            text = room?.room?.completion_popup?.middlecontent || "";
            text = text.replaceAll("{x}", `${middleStateCounter}`);
            withClose = true;
        }

        if (isCurrentPageMainroom) {
            $(this.elms.goToMainRoom).addClass("is-mainroom");
        } else {
            $(this.elms.goToMainRoom).removeClass("is-mainroom");
        }

        if (hasSeen || isCurrentPageMainroom) withClose = true;

        if (!title && !text) return;

        if ($popup.hasClass("is-open")) this.hide();

        withClose
            ? $popup.addClass("is-with-close")
            : $popup.removeClass("is-with-close");

        $popup.find(".completionPopup__title").text(title);
        if (text) $popup.find(".completionPopup__content ").html(text);
        $popup.addClass("is-open");

        if (!hasSeen) this._setHasSeen(roomId);
    }

    hide() {
        const $popup = $(this.elms.popup);
        $popup.removeClass("is-open");
    }
}
